<template>
	<div>
		<table class="table is-fullwidth no-border">
			<tbody>
				<template v-for="item in items">
					<tr>
						<td>{{item.permit}}</td>
						<td>{{item.name}}</td>
						<td>{{item.created_at}}</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>
<script>
    var Vue = require('vue');

    export default {

        data () {
			return {
				items: []
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
                axios.get('/api/mobilefoodvendor/checkedin/all')
                    .then(response => {
                        console.log(response.data);
                        this.items = response.data;
                    });
			}
		}
	}

</script>


// WEBPACK FOOTER //
// Modules/MobileFoodVendor/Resources/assets/js/components/Checkedin.vue